<template>
  <v-chart
    :option="chartOptions"
    style="width: 600px; height: 400px;"
  ></v-chart>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts";

export default {
  components: {
    "v-chart": ECharts
  },
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        xAxis: { type: "category", data: ["Jan", "Feb", "Mar", "Apr"] },
        yAxis: { type: "value" },
        series: [{ data: [5, 15, 25, 35], type: "line" }]
      }
    };
  }
};
</script>
